import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import { LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import('./lazyFullOption'));

let InboxRulesOption: LazyOption = createLazyOption(
    {
        key: 'inboxRules',
        titleStringKey: 'optionTitle_inboxRules',
        hideTitleInFullOptions: true,
        searchTermsStringKey: 'optionTitle_inboxRules',
        isHidden: () => {
            return !getUserConfiguration().SegmentationSettings.Rules || IsShadowMailboxUser();
        }, // Hide if Rules is disabled by admin
        allowedOptionKeys: ['EditInboxRule', 'InboxRules'],
    },
    lazyModule,
    m => m.default
);

export default InboxRulesOption;
